import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import brandModelService from "./brandModelService";

export const getBrandModels = createAsyncThunk(
  "brandmodel/get-brands",
  async (thunkAPI) => {
    try {
      return await brandModelService.getBrandModels();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getABrandModel = createAsyncThunk(
  "brandmodel/get-brand",
  async (id, thunkAPI) => {
    try {
      return await brandModelService.getBrandModel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createBrandModel = createAsyncThunk(
  "brandmodel/create-brand",
  async (brandData, thunkAPI) => {
    try {
      return await brandModelService.createBrandModel(brandData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateABrandModel = createAsyncThunk(
  "brandmodel/update-brand",
  async (brand, thunkAPI) => {
    try {
      return await brandModelService.updateBrandModel(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteABrandModel = createAsyncThunk(
  "brandmodel/delete-brand",
  async (id, thunkAPI) => {
    try {
      return await brandModelService.deleteBrandModel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  brands: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const brandModelSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBrandModels.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBrandModels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.brands = action.payload;
      })
      .addCase(getBrandModels.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createBrandModel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBrandModel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdBrand = action.payload;
      })
      .addCase(createBrandModel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getABrandModel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getABrandModel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.brandName = action.payload.title;
      })
      .addCase(getABrandModel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateABrandModel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateABrandModel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedBrand = action.payload;
      })
      .addCase(updateABrandModel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteABrandModel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteABrandModel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedBrand = action.payload;
      })
      .addCase(deleteABrandModel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default brandModelSlice.reducer;
